import React, { useEffect, useState, useContext } from 'react';
import moment from 'moment';
import { DatePicker } from "antd";
import Loading from './Loading';
import { Bar } from 'react-chartjs-2';
import LZString from 'lz-string';
import { Context } from '../../src/views/app';
import CommonUtils from '../util/CommonUtils';
import API from '../service/SiteKickAPIService';

function SensorDetails(props) {

  let appContex = useContext(Context);
  let userToken = appContex.user;
  let chartPlugin = [];
  const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
  const [sensorwiseChartData, setSensorwiseChartData] = useState({});
  const [loading, setLoading] = useState(true);
  const [sdr_url, setSdrUrl] = useState('');
  const user = userToken;
  let timezone = user.site_selected.site_iana_timezone;

  useEffect(() => {
    fetchSensorDetails();
  }, [])

  useEffect(() => {
    fetchSensorDetails();
  }, [date])

  const onDateChange = (date) => {
    setDate(moment(new Date(date)).format('YYYY-MM-DD'));
  }

  const fetchSensorDetails = () => {
    var payload = {
      customer_id: userToken.customer_id,
      site_id: userToken.site_selected.site_id,
      user_login: userToken.user_login,
      user_token: userToken.user_token,
      start_date: date,
      end_date: date ? date : moment().format('YYYY-MM-DD'),
      timezone: timezone
    }

    setDate(payload.end_date);
    setLoading(true);

    CommonUtils.ajax(
      {
        url: API.DATA.ENVIRONMENTAL,
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(payload)
      }
    ).then(
      (res) => {
        if (res.status && res.status.code === 200) {

          chartPlugin = [{
            afterDraw: (chart) => {
              let datasetSize = chart.data.datasets.length;
              if (datasetSize > 0) {

                let lastDataSet = chart.data.datasets[datasetSize - 1];
                // We might get with out no data dataset or one with empty data set.
                if (lastDataSet.label === 'NO DATA' && lastDataSet.noData) {
                  var ctx = chart.chart.ctx;
                  ctx.save();
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'middle';
                  ctx.font = "bold 14px sans-serif";
                  ctx.fillStyle = "rgba(0,0,0,1)";
                  ctx.fillText('No data available ...', chart.chart.width / 2, chart.chart.height / 2);
                  ctx.restore();
                }
              }
            }
          }];

          let colors = ['#48C9B0', '#F5B041', '#3498DB', '#AF7AC5', '#21B345'];
          var envUnitsMap = {
            'temperature': 'F',
            'humidity': '%',
            'co': 'ppm',
            'co2': 'ppm',
            'voc': 'ppb',
            'leak': '',
            'flow': 'Gallons'
          };
          var data = res.data;
          var dates = [];

          if (data && data.length > 0) {
            var startDate = payload.start_date;
            while (startDate <= payload.end_date) {
              dates.push(moment(startDate, 'YYYY-MM-DD').format('MMM DD'));
              startDate = moment(startDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
            }
          }

          var sensorwise_env_data = {};

          for (let d of data) {
            if (d.sensor_id === 'voc')
              continue;

            if (d.sensor_name === d.device_name)
              continue;

            if (!sensorwise_env_data[d.sensor_name])
              sensorwise_env_data[d.sensor_name] = {};

            if (!sensorwise_env_data[d.sensor_name][d.sensor_id]) {
              var date1 = moment(payload.start_date, 'YYYY-MM-DD').format('MMM DD')
              var dateMapDefaults = {};
              dateMapDefaults[date1] = [{ event_type: 'dummy', event_value: null, event_ts: date1 + ', 00:00' }];
              sensorwise_env_data[d.sensor_name][d.sensor_id] = dateMapDefaults;
            }

            let mmmdd = moment.tz(d.sec_timestamp * 1000, timezone).format('MMM DD');
            let hhmm = moment.tz(d.sec_timestamp * 1000, timezone).format('HH:mm')
            if (!sensorwise_env_data[d.sensor_name][d.sensor_id][mmmdd]) {
              sensorwise_env_data[d.sensor_name][d.sensor_id][mmmdd] = [];
            }
            let event_val = d.sensor_id === 'humidity' && d.event_value >= 100 ? 99.9 : d.event_value;
            sensorwise_env_data[d.sensor_name][d.sensor_id][mmmdd].push({ event_loc: d.location_id, event_value: event_val, event_ts: mmmdd + ', ' + hhmm });
          }

          let sensorChartMap = {};

          for (let sensor_name_key in sensorwise_env_data) {
            let sensorwise_data = {};
            let sensorIds = Object.keys(sensorwise_env_data[sensor_name_key]);
            let envParamsObj = {};

            for (var x of sensorIds) {
              envParamsObj[x] = null;
            }

            for (let sensor_id_key in sensorwise_env_data[sensor_name_key]) {
              for (let date_key in sensorwise_env_data[sensor_name_key][sensor_id_key]) {
                for (let date_key_rec of sensorwise_env_data[sensor_name_key][sensor_id_key][date_key]) {
                  if (date_key_rec.event_type === 'dummy' && sensorwise_env_data[sensor_name_key][sensor_id_key][date_key].length > 1) {
                    continue;
                  }
                  if (!sensorwise_data[date_key_rec.event_ts]) {
                    sensorwise_data[date_key_rec.event_ts] = JSON.parse(JSON.stringify(envParamsObj));
                  }
                  sensorwise_data[date_key_rec.event_ts][sensor_id_key] = date_key_rec.event_value;
                }
              }
            }

            sensorChartMap[sensor_name_key] = {
              options: {
                title: {
                  fontColor: 'rgba(0, 0, 0)',
                  display: true,
                  text: "Sensor " + sensor_name_key //"Sensor " + sensor_name_key
                },
                legend: {
                  display: true
                },
                tooltips: {
                  mode: 'single',
                  intersect: false,
                  custom: function (tooltip) {
                    if (!tooltip) return;
                    tooltip.displayColors = false;
                  },
                  callbacks: {
                    title: function (tArr, d) {
                      if (tArr && tArr.length > 0) {
                        let t = tArr[0];
                        if (d.datasets[t.datasetIndex].label === 'NO DATA') {
                          return '';
                        } else {
                          let labelData = d.datasets[t.datasetIndex].labelData;
                          let val = t.yLabel + '' + labelData.units;
                          return labelData.label + '  ' + val;
                        }
                      }
                    },
                    label: function (t, d) {
                      if (d.datasets[t.datasetIndex].label === 'NO DATA') {
                        return 'No data found...';
                      } else {
                        return t.xLabel;
                      }
                    },
                    labelTextColor: function (t, chart) {
                      let isNoDataSet = this._data.datasets[t.datasetIndex].label === 'NO DATA';
                      return isNoDataSet ? '#FFFFFF' : colors[t.datasetIndex];
                    }
                  }
                },
                scales: {
                  xAxes: [{
                    categoryPercentage: 1.0,
                    barPercentage: 1.0,
                    ticks: {
                      autoSkip: true
                    },
                    display: true,
                    gridLines: {
                      display: true
                    },
                    scaleLabel: {
                      display: true,
                      labelString: 'Hour',
                      fontColor: 'orange'
                    }
                  }],
                  yAxes: []
                },
                maintainAspectRatio: false
              },
              labels: [],
              datasets: []
            };

            let labelsDateTimeSorted = Object.keys(sensorwise_data).sort((x, y) => { return moment(x, 'MMM DD, HH:mm').diff(moment(y, 'MMM DD, HH:mm'), 'hours', true) })
            sensorChartMap[sensor_name_key].labels = labelsDateTimeSorted;
            let envParamWiseData = JSON.parse(JSON.stringify(envParamsObj));

            let idx = 0;
            for (var envParam in envParamWiseData) {
              let yKey = sensor_name_key + '-' + envParam;
              sensorChartMap[sensor_name_key].options.scales.yAxes.push(
                {
                  display: true,
                  gridLines: {
                    display: false
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "",
                    fontColor: 'orange'
                  },
                  id: yKey,
                  position: idx > 0 ? 'right' : 'left',
                  ticks: {
                    fontColor: colors[idx]
                  },
                  beforeBuildTicks: function (e) {
                    e.options.display = (e.min !== -1);
                  }
                }
              );

              let envParamData = [];
              for (let date of sensorChartMap[sensor_name_key].labels) {
                envParamData.push(sensorwise_data[date][envParam]);
              }

              let minmax = filter_sort([...envParamData]);
              sensorChartMap[sensor_name_key].datasets.push({
                type: 'line',
                labelData: { label: capitalize(envParam), min: minmax[0], max: minmax[minmax.length - 1], units: envUnitsMap[envParam] },
                label: capitalize(envParam) + " (Min: " + minmax[0] + envUnitsMap[envParam] + ", Max: " + minmax[minmax.length - 1] + envUnitsMap[envParam] + ")",
                backgroundColor: 'rgba(0,0,0,0)',
                pointHoverBorderColor: colors[idx],
                pointBackgroundColor: colors[idx],
                borderColor: colors[idx],
                hoverBackgroundColor: 'rgba(0,123,255,0.9)',
                data: envParamData,
                yAxisID: yKey,
                pointRadius: 2
              });
              idx++;
            }
            addNoDataDataSet(sensorChartMap[sensor_name_key]);
          }
          setSensorwiseChartData(sensorChartMap);
          setLoading(false);
          if (userToken.site_selected) {
            var minifiedUser = preparePDFData({ ...userToken });
            minifiedUser.date = date;
            minifiedUser.sensorKey = props.sensorKey;
            minifiedUser.sensor_serial_number = props.sensor_serial_number;
            let site_info = userToken.site_selected.site_name + ' at ' + moment.tz(new Date(), userToken.site_selected.site_iana_timezone).format('MM-DD-YYYY hh:mm a');

            setSdrUrl(API.getFullUrl('/export-pdf/sensor-details/Sensor Details - ' + site_info + '.pdf?' + LZString.compressToBase64(JSON.stringify(minifiedUser)) + '=payload&host=' + window.location.host));
          }
        }
      })
  }

  const preparePDFData = (userCopy) => {
    var pdfData = {};
    let fields = ["user_login", "user_token", "site_id", "customer_id"];
    for (let i = 0; i < fields.length; i++) {
      pdfData[fields[i]] = userCopy[fields[i]];
    }

    if (userCopy.site_selected) {
      pdfData.site_selected = {};
      let fields = ["site_id", "site_name", "site_iana_timezone", "site_city", "site_country", 'site_config'];
      for (let i = 0; i < fields.length; i++) {
        pdfData.site_selected[fields[i]] = userCopy.site_selected[fields[i]];
      }
    }

    if (userCopy.zones) {
      pdfData.zones = [];
      for (let z of userCopy.zones) {
        pdfData.zones.push({ location_name: z.location_name, location_id: z.location_id });
      }
    }

    return pdfData;
  }

  const capitalize = (s) => {
    return s.toUpperCase()
  }

  const filter_sort = (test_array) => {
    var index = -1,
      arr_length = test_array ? test_array.length : 0,
      resIndex = -1,
      result = [];

    while (++index < arr_length) {
      var value = test_array[index];

      if (value !== null) {
        result[++resIndex] = parseFloat(value);
      }
    }

    if (result.length > 0) {
      result = result.sort((a, b) => a - b);
    }

    return result.length === 0 ? ['-'] : result;
  }

  const addNoDataDataSet = (chart) => {
    let dataSetsSize = chart.datasets.length;
    let maxVal = 0;
    let dataFoundPoints = 0;
    let missingData = chart.datasets[0].data.map((v, idx) => {
      let foundVal = false;
      for (let i = 0; i < dataSetsSize; i++) {
        if (chart.datasets[i].data[idx]) {
          if (chart.datasets[i].data[idx] > maxVal) {
            maxVal = chart.datasets[i].data[idx];
          }
          foundVal = true;
        }
      }
      if (foundVal)
        dataFoundPoints++;
      return foundVal ? 0 : 1;
    });

    if (maxVal === 0 && dataFoundPoints === 0) {
      maxVal = 100;
    }

    for (let i = 0; i < missingData.length; i++) {
      if (missingData[i] === 1)
        missingData[i] = maxVal;
    }

    let dataLen = missingData.length;
    if (dataFoundPoints !== dataLen) {
      let yKey = new Date().getMilliseconds();
      let newDataSet = {
        noData: (dataFoundPoints === 0),
        type: 'bar',
        label: 'NO DATA',
        backgroundColor: '#dedede',
        borderColor: '#dedede',
        borderWidth: 0,
        hoverBackgroundColor: '#dedede',
        hoverBorderColor: '#dedede',
        data: missingData,
        yAxisID: yKey
      };
      chart.datasets.push(newDataSet);
      let ticksObj = { display: false }
      if (dataFoundPoints === 0) {
        ticksObj = {
          display: false,
          beginAtZero: true,
          steps: 10,
          stepValue: 10,
          max: 100
        };
      };
      chart.options.scales.yAxes.push({
        display: true,
        gridLines: {
          display: false
        },
        scaleLabel: {
          display: true,
          labelString: "",
          fontColor: 'orange'
        },
        ticks: ticksObj,
        id: yKey,
        position: 'right',
        beforeBuildTicks: function (e) {
          e.options.display = (e.min !== -1);
        }
      });
    }
  }

  var { sensorKey } = props;
  var sensorChartData = {};
  sensorChartData[sensorKey] = sensorwiseChartData[sensorKey] ? sensorwiseChartData[sensorKey] : {};
  return (
    <React.Fragment>
      <div className="modal-header p-2 bg-primary text-white">
        <span className="modal-title">Sensor Details</span>
        <div>
          <button type='button' className='fa fa-expand' onClick={props.resizeModal}></button>
          <button type='button' className='far fa-lg fa-times-circle pull-right' data-dismiss='modal' onClick={props.closeModal}></button>
        </div>
      </div>
      {!loading && (
        <div className="container px-2 bg-light">
          <div className="row p-1">
            <div className="col-md-4 font-weight-bold text-primary pt-1 pl-4">
              {user && user.site_selected && user.site_selected.site_name}
            </div>
            <div className="col-md-8 text-right">
              <span className="mr-2">
                <a target='_blank' rel='noopener noreferrer' href={sdr_url} className="btn btn-white btn-sm"><i className="far fa-file-pdf text-danger"></i> Download PDF</a>
              </span>
              {!props.hideDatePicker &&
                <DatePicker disabledDate={(current) => current > moment().endOf('day')} showToday={false} allowClear={false} inputReadOnly popupStyle={{ zIndex: 10000 }} onChange={onDateChange} defaultValue={moment(date, 'YYYY-MM-DD')} format={'YYYY-MM-DD'} />
              }
            </div>
          </div>
        </div>
      )}

      <div className="modal-footer bg-light" style={{ padding: "0.5rem 1rem" }}></div>
      <div className="modal-body bg-white">
        <div className="p-3">
          {loading ? (<div><center><Loading> Loading ... </Loading></center></div>) :
            <React.Fragment>
              {sensorChartData[sensorKey].datasets && sensorChartData[sensorKey].datasets.length > 0 ?
                <React.Fragment>
                  <div className="bg-primary text-white p-2 mt-2">{props.sensor_name ? props.sensor_name : props.sensor_serial_number}</div>
                  {
                    <div className="card my-2 bg-shadow" style={{ height: '350px', width: '100%', marginTop: '0px', marginBottom: '20px' }}>
                      <Bar
                        plugins={chartPlugin}
                        style={{ position: "relative" }}
                        data={sensorChartData[sensorKey]}
                        height={350}
                        options={sensorChartData[sensorKey].options}
                      />
                    </div>
                  }
                </React.Fragment> :
                <div style={{ lineHeight: '150px', textAlign: 'center', width: '100%', marginTop: '20px' }}>
                  <span>No data found ...</span>
                </div>}
            </React.Fragment>
          }
        </div>
      </div>
    </React.Fragment>
  )
}

export default SensorDetails;